import { TmElement, rem, token } from '@thiememeulenhoff/lit-sdk';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { tagName } from '../../helpers';

const tag = tagName('loader-dots');

const loaderDotsStyles = css`
  :host {
    --dot-spacing: ${rem(4)};
    --dot-size: ${rem(8)};
    --dot-color: ${token('loader-dots-background-default')};

    display: inline-flex;
    gap: var(--dot-spacing);
  }

  :where(span) {
    animation: blink 1.4s infinite both;
    background-color: var(--dot-color);
    block-size: var(--dot-size);
    border-radius: var(--dot-size);
    display: block;
    inline-size: var(--dot-size);
  }

  :where(span:nth-child(1)) {
    animation-delay: 0s;
  }

  :where(span:nth-child(2)) {
    animation-delay: 0.2s;
  }

  :where(span:nth-child(3)) {
    animation-delay: 0.4s;
  }

  @keyframes blink {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`;

@customElement(tag)
export class LoaderDotsComponent extends TmElement {
  static override styles = loaderDotsStyles;

  override render() {
    return Array.from({ length: 3 }).map(() => html`<span></span>`);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-loader-dots': LoaderDotsComponent;
  }
}
